import * as types from '../../../actions/candidate/candidate-application/types';
import Immutable from 'immutable';
import reducerCreator from '../../../tools/reducer-creator';

const initialState = Immutable.fromJS({
  applicationSummary: null,
  applicationCoverLetter: null,
  applicationSupplementaryQuestions: null,
  isApplicationSummaryLoading: false,
  isApplicationCoverLetterLoading: false,
  isApplicationSupplementaryQuestionsLoading: false,
  applicationSummaryRequestFailedCode: undefined,
  isApplicationWithdrawing: false,
  isApplicationReSubmitting: false,
  printVersionIsLoading: false
});

export default reducerCreator(initialState, {
  [types.CANDIDATE_APPLICATION_SET_APPLICATION_SUMMARY]: (state, { applicationSummary }) =>
    state.set('applicationSummary', applicationSummary),

  [types.CANDIDATE_APPLICATION_SET_COVER_LETTER_LOADING]: (state, { isLoading }) =>
    state.set('isApplicationCoverLetterLoading', isLoading),
  
  [types.CANDIDATE_APPLICATION_SET_COVER_LETTER]: (state, { candidateApplicationCoverLetter }) =>
    state.set('applicationCoverLetter', candidateApplicationCoverLetter),

  [types.CANDIDATE_APPLICATION_SET_APPLICATION_SUMMARY_LOADING]: (state, { isApplicationSummaryLoading }) =>
    state.set('isApplicationSummaryLoading', isApplicationSummaryLoading),
  
  [types.CANDIDATE_APPLICATION_SET_SUPPLEMENTARY_QUESTIONS_LOADING]: (state, { isLoading }) =>
    state.set('isApplicationSupplementaryQuestionsLoading', isLoading),

  [types.CANDIDATE_APPLICATION_SET_SUPPLEMENTARY_QUESTIONS]: (state, { candidateApplicationSupplementaryQuestions }) =>
    state.set('applicationSupplementaryQuestions', candidateApplicationSupplementaryQuestions),
  
  [types.CANDIDATE_APPLICATION_RESET_COVER_LETTER]: (state) => 
    state.set('applicationCoverLetter', null),
  
  [types.CANDIDATE_APPLICATION_RESET_SUPPLEMENTARY_QUESTIONS]: (state) => 
    state.set('applicationSupplementaryQuestions', null),
 
  [types.CANDIDATE_APPLICATION_RESET_CANDIDATE_APPLICATION_STATE]: () =>
    initialState,

  [types.CANDIDATE_APPLICATION_SET_APPLICATION_SUMMARY_REQUEST_FAILED_CODE]: (state, { applicationSummaryRequestFailedCode }) => 
    state.set('applicationSummaryRequestFailedCode', applicationSummaryRequestFailedCode),
    
  [types.CANDIDATE_APPLICATION_SET_WITHDRAWING]: (state, { isLoading }) =>
    state.set('isApplicationWithdrawing', isLoading),

  [types.CANDIDATE_APPLICATION_SET_RESUBMITTING]: (state, { isLoading }) =>
    state.set('isApplicationReSubmitting', isLoading),

  [types.CANDIDATE_APPLICATION_SET_PRINT_VERSION_IS_LOADING]: (state, { printVersionIsLoading }) =>
    state.set('printVersionIsLoading', printVersionIsLoading)
});


// WEBPACK FOOTER //
// ./src/reducers/candidate/candidate-application/candidate-application.js